export const API_URL = process.env.REACT_APP_API_URL

export const schedule_URL = API_URL + '/vaccination/schedule?labId=' + process.env.REACT_APP_LAB_ID
